import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import ClaimItem from './ClaimItem/ClaimItem'
import ClaimsCardMenu from './ClaimsCardMenu/ClaimsCardMenu'
import * as Styles from './styles'

const ClaimsCard = ({ claims, onOpenClaim, allowOpenClaim }) => {
  const { t } = useTranslation()

  if (!claims?.length) return null

  return (
    <Card showBorder={false}>
      <CardTitle>
        {t('Incidencias')}
        <Styles.MenuContainer>
          <ClaimsCardMenu onOpenClaim={onOpenClaim} allowOpenClaim={allowOpenClaim} />
        </Styles.MenuContainer>
      </CardTitle>
      <Styles.ItemsContainer>
        {claims.map(claim => (
          <ClaimItem
            key={claim.id}
            id={claim.id}
            type={claim.type}
            status={claim.status}
            message={claim.message}
            openedAt={claim.opened_at}
          />
        ))}
      </Styles.ItemsContainer>
    </Card>
  )
}

export default ClaimsCard
